import Vue from 'vue'
import Router from 'vue-router'
import TutoringRegistration from '../views/TutoringRegistration.vue'
import OrderList from '../views/OrderList.vue'
import ErrorPage from '../views/ErrorPage.vue'
import Login from '../views/Login.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/form/orgId/:orgId',
      name: 'tutoring-registration',
      component: TutoringRegistration,
      props: true,
      beforeEnter: (to, from, next) => {
        if (!to.params.orgId) {
          next('/error');
        } else {
          next();
        }
      }
    },
    {
      path: '/list/orgId/:orgId',
      name: 'order-list',
      component: OrderList,
      props: true,
      beforeEnter: (to, from, next) => {
        if (!to.params.orgId) {
          next('/error');
        } else {
          next();
        }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/error',
      name: 'error-page',
      component: ErrorPage
    }
  ]
})
